// extracted by mini-css-extract-plugin
module.exports = {"meet-your-coach":"about-meet-coach_meet-your-coach__KXb9w","meet-your-coach__card-item":"about-meet-coach_meet-your-coach__card-item__7KwrO"};